import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  setAliasState,
  setScanPackCurrentOrder,
  setScanPackCurrentItem,
  setScanPackBarcodeInput,
  handlePassButton,
  handleReloadOrder
} from '../../../actions/scanpackScanningActions';
import {updateProductList} from '../../../actions/productAction';

const useProductAlias = () => {
  const dispatch = useDispatch();
  const alias = useSelector(state => state.scanPackScanning.alias);
  const currentOrder = useSelector(state => state.scanPackScanning.currentOrder);
  const updateProductListResponse = useSelector(state => state.product.updateProductList);
  const updateProductAliasResponse = useSelector(state => state.product.updateProductAlias);

  // Watch updateProductList API response
  useEffect(() => {
    if (!alias.addBarcodeItem || !updateProductListResponse?.data) return;

    const response = updateProductListResponse.data;

    if (response.show_alias_popup) {
      dispatch(setAliasState({
        aliasVisible: true,
        addBarcodeWindow: false,
        productData: response
      }));
      dispatch(updateProductList(null));
      return;
    }

    // Success — update item barcodes locally
    const productId = alias.addBarcodeItem.product_id;
    const newBarcode = {
      barcode: alias.addBarcodeText,
      created_at: '',
      id: 0,
      packing_count: '1',
      product_id: productId,
      updated_at: new Date()
    };

    const updatedUnscanned = currentOrder?.unscanned_items?.map(item => {
      if (item.child_items?.length > 0) {
        return {
          ...item,
          child_items: item.child_items.map(child =>
            child.product_id === productId
              ? {...child, barcodes: [newBarcode]}
              : child
          )
        };
      }
      if (item.product_id === productId) {
        return {...item, barcodes: [newBarcode]};
      }
      return item;
    });

    const updatedOrder = {
      ...currentOrder,
      unscanned_items: updatedUnscanned
    };

    const updatedItem = updatedUnscanned?.find(item => item.product_id === productId);
    if (updatedItem) {
      dispatch(setScanPackCurrentItem(updatedItem));
    }

    dispatch(setScanPackCurrentOrder(updatedOrder));
    dispatch(setAliasState({
      addBarcodeWindow: false,
      addBarcodeText: '',
      addBarcodeItem: null
    }));
    dispatch(setScanPackBarcodeInput(''));
    dispatch(handlePassButton());
    dispatch(updateProductList(null));
  }, [updateProductListResponse]);

  // Watch updateProductAlias API response
  useEffect(() => {
    if (!alias.productData || !updateProductAliasResponse?.status) return;

    dispatch(handleReloadOrder());
    dispatch(setAliasState({
      aliasVisible: false,
      shareBarcodeShow: false,
      addBarcodeWindow: false,
      addBarcodeText: '',
      addBarcodeItem: null,
      productData: null
    }));
  }, [updateProductAliasResponse]);
};

export default useProductAlias;
